import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=bb790d52&scoped=true"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=bb790d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb790d52",
  null
  
)

export default component.exports